import { Form, Select } from "antd";

import { useAccounts } from "../../data/use-accounts";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const AccountSelect = (props) => {
  const accounts = useAccounts();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        options={getSelectOptions({
          store: accounts,
          initialIds: initialValue,
          filter: props.filter,
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
